// reducer.js
const initialState = {
  FileList: [],
};

const filesUploadReducer = (state = initialState, action:any) => {
  switch (action.type) {
    case 'SET_TOTAL_FILES':
      return {
        ...state,
        FileList: action.payload,
      };
    default:
      return state;
  }
};

export default filesUploadReducer;
